"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeOptions = exports.asOptions = exports.UX_SPACE_SIZE = exports.UX_SPACE_AS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Each key is a named level of density.
 * Each factor is a number which is multiplied against
 *  the grid unit (intents.ux.box.density) value which determines the space.
 */
const UX_SPACE_AS = exports.UX_SPACE_AS = {
  module: {
    paddingFactor: 8,
    gapFactor: 3
  },
  block: {
    paddingFactor: 5,
    gapFactor: 3
  },
  lockup: {
    paddingFactor: 2,
    gapFactor: 1
  }
};
const UX_SPACE_SIZE = exports.UX_SPACE_SIZE = {
  sm: {
    paddingFactor: 1,
    gapFactor: 1
  },
  md: {
    paddingFactor: 2,
    gapFactor: 2
  },
  lg: {
    paddingFactor: 3,
    gapFactor: 3
  },
  xl: {
    paddingFactor: 5,
    gapFactor: 5
  }
};
const asOptions = exports.asOptions = Object.keys(UX_SPACE_AS).reduce((acc, key) => _objectSpread({
  [key.toUpperCase()]: key
}, acc), []);
const sizeOptions = exports.sizeOptions = Object.keys(UX_SPACE_SIZE).reduce((acc, key) => _objectSpread({
  [key.toUpperCase()]: key
}, acc), []);